/**
 * Generated by orval v8.4.2 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Whether the event was extracted by the pipeline or added manually
 */
export type ChronologyEventOrigin =
  (typeof ChronologyEventOrigin)[keyof typeof ChronologyEventOrigin];

export const ChronologyEventOrigin = {
  EXTRACTED: "EXTRACTED",
  MANUAL: "MANUAL",
} as const;
